<template>
  <v-container fluid pa-0>
    <SmsLogTable />
  </v-container>
</template>

<script>
import SmsLogTable from '../../modules/smsLog/components/SmsLogTable.vue'

export default {
  name: 'SmsLog',

  components: {
    SmsLogTable
  }
}
</script>
